import BGTaskRestService from '../rest/BGTaskRestService'
import React from "react";

class BGTaskService {
 
    static get(configId: number) {
        return BGTaskRestService.get(configId)
    }

    static async getTasks(setTasks: Function, configId: number) {
        const tasks: [] = await BGTaskRestService.get(configId)
        setTasks(tasks)
    }

    static getByID(id: number) {
        return BGTaskRestService.getById(id)
    }

    static async createTask(scheduleId: number, reload: boolean, setReload: React.Dispatch<any>) {
        try {
            await BGTaskRestService.create(scheduleId)
            setReload(!reload)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async cancel(scheduleId: number, reload: boolean, setReload: React.Dispatch<any>) {
        try {
            await BGTaskRestService.cancel(scheduleId)
            setReload(reload)
        } catch (error) {
            return Promise.reject(error)
        }
    }
}
export default BGTaskService
